import { jsx as _jsx } from "react/jsx-runtime";
import { TableHead as MuiTableHead, styled, } from '@mui/material';
import { font } from '../../styles';
const MuiTableHeadStyled = styled(MuiTableHead)(({ stickyTop, cellSize }) => ({
    ...(stickyTop
        ? {
            zIndex: 1,
            position: 'sticky',
            top: stickyTop,
        }
        : {}),
    '& > .MuiTableRow-root': {
        border: 0,
        '& > th': {
            padding: cellSize === 'small' ? 0 : 1.5,
            fontWeight: 'fontWeightMedium',
            fontSize: cellSize === 'small' && font.size.s,
        },
    },
}));
export const TableHead = ({ stickyTop, cellSize, ...props }) => (_jsx(MuiTableHeadStyled, { stickyTop: stickyTop, cellSize: cellSize, ...props }));
